// constants
//-----------------------------------------------------------------------------
//settings.PREFER_ENV = ENV.WEBGL;

// constants
//-----------------------------------------------------------------------------
export default {
  limitFPS: false, // 60 will cause fps gaps on some OS, probably rounding error
  size: {
    width: 720,
    height: 1280,
  },
  stats: {
    enabled: false,
  },
  stage: {
    alwaysOnAccessibility: false,
    accessibilityDebug: false,
    backgroundColor: 0x000000,
    clearBeforeRender: true,
    resolution: 1,
    antialias: false,
  },
};
